/**
 * client/hud/matchstore.ts — the last known match standings, shared by the HUD (writer) and the
 * menus' end screen (reader). The app calls menus.show('end') without data (client/game/app.ts),
 * so the end screen reads the final scoreboard from here. CONTRACT-REQUEST #H1.2 asks for the
 * `end` control message to be passed as show('end', data); when it is, that data wins.
 *
 * OWNER: HUD-UI-AUDIO agent.
 */
import type { ScoreRow } from '@shared/types';
import type { ClientWorld } from '../types';

export interface MatchSnapshot {
  localClientNum: number;
  rows: ScoreRow[];
  names: Map<number, string>;
}

class MatchStore {
  snap: MatchSnapshot = { localClientNum: -1, rows: [], names: new Map() };
  update(world: ClientWorld): void {
    if (!world.connected && world.scoreboard.length === 0) return;
    if (world.scoreboard.length) this.snap.rows = world.scoreboard.map((r) => ({ ...r }));
    this.snap.localClientNum = world.localClientNum;
    for (const [cn, info] of world.playerInfo) this.snap.names.set(cn, info.name);
  }
  reset(): void { this.snap = { localClientNum: -1, rows: [], names: new Map() }; }
}

export const matchStore = new MatchStore();
